import { createClient } from "@supabase/supabase-js";

// Browser client. Only the anon key ever reaches the bundle (constitution Principle 5:
// identity ≠ data-access; the service_role key is server-side only). RLS is what makes
// the anon key safe to ship — every row read is family-scoped in Postgres.
const url = import.meta.env.VITE_SUPABASE_URL;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !anon) {
  // Fail loud, not silent (constitution Principle 4): a misconfigured build must be obvious.
  throw new Error(
    "Missing VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY. Copy .env.example → .env and fill in."
  );
}

export const supabase = createClient(url, anon, {
  auth: { persistSession: true, autoRefreshToken: true },
});
